// Мобильный слайдер с нумерованными шагами: активный номер подсвечивается при свайпе
export default function stepCarousel() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-step-carousel]').forEach((root) => {
    const track = root.querySelector('[data-step-track]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const cards = track ? [...track.children] : [];
    if (!track || cards.length < 1 || steps.length !== cards.length) return;

    // Номер активного шага пробрасывается наружу, чтобы синхронизировать иллюстрацию
    const scope = root.closest('[data-step-scope]');

    const offsetOf = (card) => card.offsetLeft - cards[0].offsetLeft;

    function setActive(index) {
      if (scope) scope.dataset.step = index + 1;
      const stepKey = steps[index].dataset.stepKey;
      steps.forEach((step, stepIndex) => {
        if (stepIndex === index) step.setAttribute('aria-current', 'true');
        else step.removeAttribute('aria-current');
      });
      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
      if (scope) {
        scope.querySelectorAll('[data-check-mobile-visual]').forEach((visual) => {
          visual.classList.toggle('is-active', visual.dataset.stepKey === stepKey);
        });
      }
    }

    steps.forEach((step, index) => {
      step.addEventListener('click', () => {
        setActive(index);
        track.scrollTo({
          left: offsetOf(cards[index]),
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      });
    });

    let scrollFrame = 0;
    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        const activeIndex = cards.reduce((closest, card, index) =>
          Math.abs(offsetOf(card) - track.scrollLeft) < Math.abs(offsetOf(cards[closest]) - track.scrollLeft)
            ? index : closest, 0);
        setActive(activeIndex);
      });
    }, { passive: true });

    setActive(0);
  });
}
